import { getHiddenElementHeight, getTransitionEndEvent } from '../_helper/element-helper';

const $smAccordions = document.querySelectorAll('[data-sm-type="accordion"]');
const contentHeights = {};

const ACCORDION_EXPANDED = 'expanded';
const ACCORDION_COLLAPSED = 'collapsed';
let transitionEndEvent = null;

const toggleAriaAttributes = ($el, attributeName) => {
    if ($el.getAttribute(`aria-${attributeName}`) === 'false') {
        $el.setAttribute(`aria-${attributeName}`, 'true');
    } else {
        $el.setAttribute(`aria-${attributeName}`, 'false');
    }
};

/**
 * calculates the heights of the accordion contents
 * and saves them accordingly to their appearance on the page into an object
 *
 * gets called on init and on window resize
 */
const calculateHeights = () => {
    Array.prototype.forEach.call($smAccordions, ($smAccordion, index) => {
        const $content = $smAccordion.querySelector('[data-sm-accordion-content]');

        contentHeights[index] = getHiddenElementHeight($content);
        if ($content.getAttribute('data-sm-accordion-content') === ACCORDION_EXPANDED) {
            $content.style.height = `${getHiddenElementHeight($content)}px`;
        }
    });
};

/**
 * @param $heading
 * @param $content
 * @param index
 */
const openAccordion = ($heading, $content, index) => {
    $content.setAttribute('data-sm-accordion-content', ACCORDION_EXPANDED);

    toggleAriaAttributes($content, 'expanded');
    toggleAriaAttributes($heading, 'expanded');

    $heading.classList.add(ACCORDION_EXPANDED);
    $content.style.height = `${contentHeights[index]}px`;

    $content.addEventListener(transitionEndEvent, () => {
        const actualHeight = getHiddenElementHeight($content);
        if (actualHeight !== contentHeights[index] && $content.getAttribute('data-sm-accordion-content') === ACCORDION_EXPANDED) {
            contentHeights[index] = actualHeight;
            $content.style.height = `${actualHeight}px`;
        }
    }, false);
};

/**
 * @param $heading
 * @param $content
 */
const closeAccordion = ($heading, $content) => {
    $content.setAttribute('data-sm-accordion-content', ACCORDION_COLLAPSED);

    toggleAriaAttributes($content, 'expanded');
    toggleAriaAttributes($heading, 'expanded');

    $heading.classList.remove(ACCORDION_EXPANDED);

    $content.style.height = '0';
};

/**
 * @param $heading
 * @param $content
 * @param index
 */
const toggleAccordion = ($heading, $content, index) => {
    if ($content.getAttribute('data-sm-accordion-content') === ACCORDION_COLLAPSED) {
        openAccordion($heading, $content, index);
    } else {
        closeAccordion($heading, $content);
    }
};

/**
 * init flextemplate accordions
 */
const initialize = () => {
    if (!$smAccordions) {
        return;
    }

    transitionEndEvent = getTransitionEndEvent();

    Array.prototype.forEach.call($smAccordions, ($smAccordion, index) => {
        const $heading = $smAccordion.querySelector('[data-sm-toggle="collapse"]');
        const $content = $smAccordion.querySelector('[data-sm-accordion-content]');

        contentHeights[index] = getHiddenElementHeight($content);

        if ($smAccordion.classList.contains('accordion-panel--active')) {
            openAccordion($heading, $content, index);
        }

        $heading.addEventListener('click', (e) => {
            const $siblings = $smAccordion.parentNode.children;

            Array.prototype.forEach.call($siblings, ($sibling, siblingIndex) => {
                const $siblingHeading = $sibling.querySelector('[data-sm-toggle="collapse"]');
                const $siblingContent = $sibling.querySelector('[data-sm-accordion-content]');

                if ($siblingHeading === e.target) {
                    return;
                }

                if ($siblingContent.getAttribute('data-sm-accordion-content') === ACCORDION_EXPANDED) {
                    closeAccordion($siblingHeading, $siblingContent, siblingIndex);
                }
            });

            toggleAccordion($heading, $content, index);
        });
    });

    window.addEventListener('resize', calculateHeights);
};

export default () => {
    initialize();
};
